import React, { useEffect, useState } from 'react';
import { BsPlus } from 'react-icons/bs';
import { useNavigate } from 'react-router';
import { getPermission } from '../../../Conexiones/Conexion';
import { Link } from "react-router-dom";
import { Button, CloseButton, Modal } from 'react-bootstrap';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { getApi, postApi, putApi, deleteApi } from '../../../Conexiones/Models';
import { errorMessage, errorToast, successToast, warningModal, warningToast } from '../../../Utils/AlertMessage';
import Loading from '../../../Utils/Loading';

function Actividades() {
    const [actividades, setActividades] = useState([]);
    const navigate = useNavigate();
    const [busqueda, setBusqueda] = useState("");
    const [tablaAct, setTablaAct] = useState([]);
    const [nombre, setNombre] = useState();
    const [isSaving, setSaving] = useState(false);
    const [editNombre,setEditNombre] = useState ();
    const [idAct,setIdAct] = useState ();
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUsuario = usuario[0].idUsuario;
    const [isLoading,setIsLoading]=useState(false);
    const uri = 'actividades/';

    //AGREGAR
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    //EDITAR
    const [showEdit, setShowEdit] = useState(false);
    const handleCloseEdit = () => setShowEdit(false);
    const handleShowEdit = (id,nombre) =>{
        setShowEdit(true);
        setEditNombre(nombre);
        setIdAct(id);
    } 

    const getAct = async () => {
        const endpoint = uri;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setActividades(res.data);
                setTablaAct(res.data);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    };

    useEffect(() => {
        const getAct = async () => {
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,0);
            if(permiso){
                const endpoint = uri;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setActividades(res.data);
                        setTablaAct(res.data);
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
                /*const res = await axios.get(URI+'actividades/',{
                    headers: {
                        'Authorization': `Bearer ${getToken()}`
                    },
                    }).catch(
                        err =>{
                            if(err.response.data === "Token Inválido" | err.response.data === "Token requerido"){
                                navigate('/')
                            }
                        }
                    )
                setActividades(res.data);
                setTablaAct(res.data);*/
            }else{
                navigate('/inicio')
            }
            setIsLoading(false);
        };
        getAct();
    },[idUsuario,navigate]);

    const select = (id) => {
        sessionStorage.setItem("catAct", id);
        navigate("SubActividades");
    };

    const regresar = () => {
        navigate('/inicio/Catalogos')
    }


    const buscar = e => {
        setBusqueda(e.target.value)
        filtrar(e.target.value)
    }

    const filtrar = (texto) => {
        var resBusqueda = tablaAct.filter((elemento)=> {
            if  (elemento.nombreActCat.toString().toLowerCase().includes(texto.toLowerCase())){  
                return elemento; 
            }
            return resBusqueda
        })
        setActividades(resBusqueda)
    }
    //AGREGAR ACTIVIDAD
    const store = async (e) =>{
        e.preventDefault()
        setSaving(true);
        if(nombre.trim().length === 0){
            warningToast('CAMPOS VACIOS','EL CAMPO NOMBRE ESTA VACÍO');
        }else{
            const data = {nombreAct:nombre}
            const endpoint = uri;
            const res = await postApi(endpoint,data)
            if(res.status === 1){
                if(res.data.message==="¡Registro creado correctamente!"){
                    handleClose();
                    getAct();
                    successToast("AGREGADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
            /*await axios.post(URI + 'actividades/', {nombreAct:nombre}).then(
                res => {                
                    if(res.data.message === "connect ECONNREFUSED 127.0.0.1:3306"){
                        Swal.fire(
                            'Falla en el servidor...',
                            'Intente más tarde',
                            'question'
                        )
                    }else{
                        if(res.data.message==="¡Registro creado correctamente!"){
                            getAct();
                            Swal.fire({
                                icon: 'success',
                                title: '¡ACTIVIDAD AGREGADA CORRECTAMENTE!',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                target: document.getElementById('modal-agregar-actividad')
                            }).then((result) => {
                                if (result.isConfirmed) {
                                   handleClose();
                                } 
                            })
                        }else{
                            Swal.fire({
                                title: '¡ERROR!',
                                text: res.data.message,                 
                                icon: 'error',
                                confirmButtonColor: 'red',
                                allowOutsideClick: false,
                                confirmButtonText: 'ACEPTAR',
                                target: document.getElementById('modal-agregar-actividad')
                            })
                        }
                    }
                }
            ).catch(
                err => {
                    if(err.message === "Network Error"){
                        Swal.fire(
                            'Falla en el servidor...',
                            'Intente más tarde',
                            'question'
                        )
                    }else{
                        Swal.fire(
                            'Falla en el servidor...',
                            err.message,
                            'question'
                        )
                    }
                }
            )*/
        }
        setSaving(false);
    }

    //ELIMINAR ACTIVIDAD
    const eliminarAct = async (id) =>{
        const endpoint = 'validarChildrens/'+id+"/"+1;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if (res.data.message === "Esta categoría contiene actividades registradas") {
                errorToast("¡NO SE PUEDE ELIMINAR!",res.data.message)
            } else {
                warningModal('¿QUIERES ELIMINAR ESTA CATEGORIA?')
                .then(async (result)  => {
                    if (result.isConfirmed) {
                        const endpoint = 'eliminarAct/'+id+"/"+1;
                        const res = await deleteApi(endpoint);
                        if(res.status === 1){
                            if(res.data.message==="registro eliminado"){
                                getAct();
                                successToast("ELIMINADO");
                            }else{
                                errorToast("¡ERROR!",res.data.message);
                            }
                        }else if(res.status === 210){
                            navigate('/');
                        }else{
                            errorMessage(res.message);
                        }
                    }
                })
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
        /*await axios.get(URI+'validarChildrens/'+id+"/"+1,{
            headers: {
                'Authorization': `Bearer ${getToken()}`
            },
            }).then(
            res => {
                if (res.data.message === "Esta categoría contiene actividades registradas") {
                    Swal.fire({
                        title: '¡NO SE PUEDE ELIMINAR!',
                        text: res.data.message,                 
                        icon: 'error',
                        confirmButtonColor: 'red',
                        allowOutsideClick: false,
                        confirmButtonText: 'ACEPTAR'
                    })
                } else {
                    Swal.fire({
                        title: '¿QUIERES ELIMINAR ESTA CATEGORIA?',
                        icon: 'warning',
                        iconColor:'#1e2c4f',
                        color: '#1e2c4f',
                        showCancelButton: true,
                        confirmButtonColor: '#1e2c4f',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'ELIMINAR',
                        cancelButtonText: 'CANCELAR'
                    }).then(async (result)  => {
                        if (result.isConfirmed) {
                            await axios.delete(URI+'eliminarAct/'+id+"/"+1,{
                                headers: {
                                    'Authorization': `Bearer ${getToken()}`
                                },
                                }).then(
                                res => {
                                    if (res.data.message === "connect ECONNREFUSED 127.0.0.1:3306") {
                                        Swal.fire(
                                            'Falla en el servidor...',
                                            'Intente más tarde',
                                            'question'
                                        )
                                    } else {
                                        if (res.data.message === "registro eliminado") {
                                            Swal.fire(
                                                {
                                                    title: '¡ELIMINADO!',
                                                    text: 'LA CATEGORIA HA SIDO ELIMINADA',                 
                                                    icon: 'success',
                                                    confirmButtonColor: 'red',
                                                    allowOutsideClick: false,
                                                    confirmButtonText: 'ACEPTAR'
                                                }
                                            ).then((result) => {
                                                if (result.isConfirmed) {
                                                    getAct();
                                                }
                                            })
                                        }else{
                                            Swal.fire({
                                                title: '¡ERROR!',
                                                text: res.data.message,                 
                                                icon: 'error',
                                                confirmButtonColor: 'red',
                                                allowOutsideClick: false,
                                                confirmButtonText: 'ACEPTAR'
                                            })
                                        }
                                    }
                                }
                            ).catch(
                                err => {
                                    if(err.message === "Network Error"){
                                        Swal.fire(
                                            'Falla en el servidor...',
                                            'Intente más tarde',
                                            'question'
                                        )
                                    }else{
                                        Swal.fire(
                                            'Falla en el servidor...',
                                            err.message,
                                            'question'
                                        )
                                    }
                                }
                            )
                        }
                    })
                }
            }
        ).catch(
            err => {
                if(err.message === "Network Error"){
                    Swal.fire(
                        'Falla en el servidor...',
                        'Intente más tarde',
                        'question'
                    )
                }else{
                    Swal.fire(
                        'Falla en el servidor...',
                        err.message,
                        'question'
                    )
                }
            }
        )*/
    }

    //EDITAR ACTIVIDAD
    const update= async (e) => {
        e.preventDefault()
        if(editNombre.trim().length === 0){
            warningToast('CAMPOS VACIOS');
        }else{
            const endpoint = 'updateActividad/'+idAct;
            const data = {nombreAct:editNombre};
            const res = await putApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="Registro modificado"){
                    handleCloseEdit();
                    getAct();
                    successToast("EDITADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
            /*await axios.put(URI+'updateActividad/'+idAct,{nombreAct:editNombre}).then(
                res => {                
                    if(res.data.message === "connect ECONNREFUSED 127.0.0.1:3306"){
                        Swal.fire(
                            'Falla en el servidor...',
                            'Intente más tarde',
                            'question'
                            )
                    }else{
                        if(res.data.message==="Registro modificado"){
                            getAct();
                            Swal.fire({
                                icon: 'success',
                                title: '¡ACTIVIDAD MODIFICADA CORRECTAMENTE!',
                                showConfirmButton: true,
                                target: document.getElementById('modal-editar-actividad')
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    //window.location.reload();
                                    handleCloseEdit();
                                } 
                            })
                        }else{
                            Swal.fire({
                                title: '¡ERROR!',
                                text: res.data.message,                 
                                icon: 'error',
                                confirmButtonColor: 'red',
                                allowOutsideClick: false,
                                confirmButtonText: 'ACEPTAR'
                            })
                        }
                    }
                }
            ).catch(
                err => {
                    if(err.message === "Network Error"){
                        Swal.fire(
                            'Falla en el servidor...',
                            'Intente más tarde',
                            'question'
                            )
                    }else{
                        Swal.fire(
                            'Falla en el servidor...',
                            err.message,
                            'question'
                        )
                    }
                }
            )*/
        }
    }

    return (
        <div className='herramientas' >
            {
                isLoading === true ? 
                <Loading />:
                <div>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label>CATEGORIA DE ACTIVIDADES</label>
                    </div>
                    {/*<div>
                        <h3 className='tituloGastos'>CATEGORIA DE ACTIVIDADES</h3>
                        <IoArrowUndo title="REGRESAR" onClick={regresar} style={{position:'absolute', right:'40px', top:'60px', fontSize:'40px', cursor:'pointer', color:'#1A2E4F'}}/>
                    </div>*/}

                    <div className='divbotonA' style={{marginTop:"20px"}} >                                                                                             
                        <div className='botonA' style={{display:'flex', justifyContent:'space-between',paddingLeft:'20px'}} >
                            <button title='Agregar Area' style={{justifyContent:'center'}} className="btn btn-light btncolor" onClick={handleShow} type="button">
                                <label className="agregar">ACTIVIDAD</label><BsPlus style={{fontSize:'25px'}}/>
                            </button>
                            <input type="search" placeholder="Nombre de la actividad" value={busqueda} onChange={buscar} className="form-control" style={{width:'50%'}} aria-describedby="basic-addon1"/> 
                        </div>
                    </div>
                    <div style={{paddingLeft:'20px',marginTop:"20px"}}>
                        <div className="row row-cols-1 row-cols-md-4 g-4" >
                            {actividades.map((a) =>{
                                return(   
                                    <div className="col-sm-6 mb-3 mb-sm-0" key={a.idFirst}>       
                                        <div className="card " >
                                            <div style={{display:"flex"}}>
                                                <div style={{display:"inline-block",width:"30%"}}>
                                                    <div  onClick={() => handleShowEdit(a.idFirst,a.nombreActCat)}  style={{fontSize:"30px",borderBottom:"1px solid #000000"}} >
                                                        <span className="bi bi-pencil-fill" title="EDITAR" ></span>
                                                    </div>
                                                    <div  style={{fontSize:"30px"}} onClick={() => eliminarAct(a.idFirst)} >
                                                        <span className="bi bi-trash-fill" title="ELIMINAR" ></span>
                                                    </div>
                                                </div>
                                                <div className="btncolor1" onClick={() => select(a.idFirst)}  as={Link} to={"SubActividades"} style={{ textAlign: "center",fontSize:'20px',display:"inline-block",width:"80%"}}>
                                                    <div className="card-body">
                                                        <div style={{justifyContent:'center',fontSize:"10px"}}>{a.codigoActCat}</div>
                                                        <div style={{justifyContent:'center',fontSize:"15px"}}>{a.nombreActCat.toUpperCase()}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>

                    {/*AGREGAR ACTIVIDAD*/}
                    <Modal show={show} onHide={handleClose} id="modal-agregar-actividad">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>AGREGAR ACTIVIDAD</Modal.Title>
                            <CloseButton onClick={handleClose} style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <form onSubmit={store}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', marginTop:'-20px'}}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">NOMBRE <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="text" className="form-control"  id="exampleFormControlInput1" required 
                                    onChange={e => setNombre(e.target.value) } />
                                </div>  
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={handleClose}>CANCELAR</Button>                                               
                                {isSaving===true? 
                                    <Button className="btn btn-primary" type="button" disabled >
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </Button>:
                                    <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                
                                }
                            </Modal.Footer>
                        </form>
                    </Modal>  

                    {/*EDITAR ACTIVIDAD*/}
                    <Modal  show={showEdit} onHide={handleCloseEdit} id="modal-editar-actividad">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>EDITAR ACTIVIDAD</Modal.Title>
                            <CloseButton onClick={handleCloseEdit} style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <form onSubmit={update}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', marginTop:'-20px'}}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">NOMBRE <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="text" className="form-control"  id="exampleFormControlInput1" required 
                                    onChange={e => setEditNombre(e.target.value)} defaultValue={editNombre}/>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={handleCloseEdit}>CANCELAR</Button>                                               
                                {isSaving===true? 
                                    <Button className="btn btn-primary" type="button" disabled >
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </Button>:
                                    <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                
                                }
                            </Modal.Footer>
                        </form>
                    </Modal>
                </div>
            }
        </div>
    );
}

export default Actividades;